/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DuplicateItemsModal from 'shared/ui/components/modals/DuplicateItemsModal.vue';
import BulkEditor from 'shared/ui/components/modals/BulkEditor.vue';
import TimeshiftModal from 'shared/ui/components/modals/TimeshiftModal.vue';

const __vue_script__ = {
    name: 'BulkActions',

    props: {
        controller: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        module: {
            type: Object,
            required: true
        },

        selectedItems: {
            type: Array,
            required: true
        }
    },

    data() {
        const { crudOpts } = this.controller.routeOptions;
        const fpType = this.selectedItems[0].fp_type;

        return {
            fpType,
            fpTypeIsBulkEditable: false,
            showDeleteButtons: !crudOpts.hideDelete,
            showDuplicateButton: false,
            showTimeShiftButton: false
        };
    },

    computed: {
        showBulkEditButton() {
            return this.fpTypeIsBulkEditable & this.selectedItems.length > 1;
        }
    },

    async created() {
        this.fpTypeIsBulkEditable = await this.$services.metadata.isFpTypeBulkEditable(this.event._id, this.fpType);
        this.showDuplicateButton = await this.$services.metadata.isFpTypeDuplicable(this.event._id, this.fpType);
        this.showTimeShiftButton = await this.$services.metadata.isFpTypeTimeShiftable(this.event._id, this.fpType);
    },

    methods: {
        promptSelectedItemsDeletion() {
            this.$modal.show('dialog', {
                text: this.$t('listings.messages.items_deletion_prompt'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('listings.actions.delete'),
                        handler: () => {
                            this.deleteSelectedItems();
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        async deleteSelectedItems() {
            try {
                const fpExtIds = this.selectedItems.map(i => i.fp_ext_id);

                await this.$services.documents.deleteDocs(this.event._id, this.event.node, this.fpType, fpExtIds);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.tc('listings.messages.items_deleted', [this.selectedItems.length]).toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$emit('reload');
            } catch (error) {
                console.error('[BulkActions] Error deleting items: ', error);
            }
        },

        openDuplicationModal() {
            this.$modal.show(DuplicateItemsModal, {
                items: this.selectedItems,
                event: this.event,
                fpType: this.fpType,
                onError: error => console.error('[BulkActions] Error duplicating items: ', error),
                onComplete: () => this.$emit('reload')
            }, {
                classes: 'small',
                height: 'auto'
            });
        },

        openModalBulkEdit() {
            this.$modal.show(BulkEditor, {
                title: this.$t('listings.labels.bulk_edit', [this.fpType]),
                introText: 'listings.messages.bulk_edit_intro',
                submitLabel: 'listings.actions.bulk_update',
                event: this.event,
                fpType: this.fpType,
                items: this.selectedItems,
                onSuccess: () => this.$emit('reload')
            }, {
                classes: 'small',
                height: 'auto'
            });
        },

        openModalTimeShift() {
            this.$modal.show(TimeshiftModal, {
                event: this.event,
                fpType: this.fpType,
                items: this.selectedItems,
                onSuccess: () => this.$emit('reload')
            }, {
                classes: 'small',
                height: 'auto'
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-actions bulk"},[(_vm.showDeleteButtons)?_c('button',{staticClass:"btn danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.promptSelectedItemsDeletion()}}},[_vm._v(_vm._s(_vm.$t('general.delete')))]):_vm._e(),(_vm.showDuplicateButton)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openDuplicationModal()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.duplicate')))]):_vm._e(),(_vm.showBulkEditButton)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openModalBulkEdit()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.bulk_edit')))]):_vm._e(),(_vm.showTimeShiftButton)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.openModalTimeShift()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.time_shift')))]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BulkActions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__